import { render, staticRenderFns } from "./project-subevents.vue?vue&type=template&id=e195b978&scoped=true&"
import script from "./project-subevents.vue?vue&type=script&lang=js&"
export * from "./project-subevents.vue?vue&type=script&lang=js&"
import style0 from "./project-subevents.vue?vue&type=style&index=0&id=e195b978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e195b978",
  null
  
)

export default component.exports